import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {Order, Product, StandardName} from "../../../store/state/order.state";
import {CompanyHasCertificateFormService} from "./company-has-certificate-form.service";
import {FormGroup} from "@angular/forms";
import * as _ from 'lodash';
import {StandaloneFormComponent} from "../../../umbrella-common/components/standalone-form.component";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {LocaleService} from "../../../umbrella-common/services/locale.service";

@Component({
    selector: 'company-has-certificate',
    templateUrl: './company-has-certificate.template.html',
    styleUrls: ['./company-has-certificate.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CompanyHasCertificateComponent extends StandaloneFormComponent implements OnInit, OnChanges {

	@Input() order: Order;
	@Input() anyProductSelected: boolean;
	@Input() multisiteButtonVisible: boolean;

	form: FormGroup;
	multisiteDisabled$: Observable<boolean>;
	showExtendedInfo: boolean;

	constructor(private localeService: LocaleService, private formService: CompanyHasCertificateFormService) {
		super(formService);
	}

	ngOnInit(): void {
		this.form = this.formService.buildStandaloneForm(this.order);
		this.multisiteDisabled$ = this.formService.inputsEnabled().pipe(map(enabled => !enabled));
		this.showExtendedInfo = this.localeService.currentLocale() != 'es-MX';
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['order'] && changes['order'].previousValue && this.productsChanged(changes['order'].previousValue, changes['order'].currentValue)) {
			this.formService.destroy();
			this.form = this.formService.buildStandaloneForm(this.order);
		}
	}

	shouldDisableRadio(product: Product): boolean {
		return this.formService.isFormInitialized() && this.getFormControl(this.getFormControlName(product)).disabled;
	}

	getFormControlName(product: Product): string {
		return 'hasCertificate_' + product.standard.name;
	}

	getStandardName(product: Product): string {
		return product.standard.name.replace('_', ' ');
	}

	updateHasCertificate(product: Product, hasCertificate: boolean) {
		this.updateFormControl(this.getFormControlName(product), hasCertificate);
	}

	private productsChanged(previousOrder: Order, currentOrder: Order) {
		const previousStandards: string[] = previousOrder.products.map(p => p.standard.name);
		const currentStandards: string[] = currentOrder.products.map(p => p.standard.name);
		return !_.isEqual(previousStandards.sort(), currentStandards.sort());
	}

	multisiteRedirectionContactFormUrl(): string {
		if (this.order.products.find(product => product.standard.name == StandardName.ISO_27701)) {
			return "company-has-certificate.27701-contact-form-link";
		} else if (this.order.products.find(product => product.standard.name == StandardName.ISO_27001)) {
			return "company-has-certificate.27001-contact-form-link";
		} else if (this.order.products.find(product => product.standard.name == StandardName.ISO_45001)) {
			return "company-has-certificate.45001-contact-form-link";
		} else if (this.order.products.find(product => product.standard.name == StandardName.ISO_14001)) {
			return "company-has-certificate.14001-contact-form-link";
		} else {
			return "company-has-certificate.9001-contact-form-link";
		}
	}

	multisiteRedirectionMultisiteHereUrl(): string {
		if (this.order.products.find(product => product.standard.name == StandardName.ISO_27701)) {
			return "company-has-certificate.27701-link-multisite-here";
		} else if (this.order.products.find(product => product.standard.name == StandardName.ISO_27001)) {
			return "company-has-certificate.27001-link-multisite-here";
		} else if (this.order.products.find(product => product.standard.name == StandardName.ISO_45001)) {
			return "company-has-certificate.45001-link-multisite-here";
		} else if (this.order.products.find(product => product.standard.name == StandardName.ISO_14001)) {
			return "company-has-certificate.14001-link-multisite-here";
		} else {
			return "company-has-certificate.9001-link-multisite-here";
		}
	}
}
